/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function Developers() {
  return (
    <>
      <div className="section section-dark text-center gradient-background-claro">
        <Container>
          <h2 className="title gradient-title"> Developers </h2>
          <hr style={{ clear: 'both' }} />
          <Row>

            <Col md="6">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.youtube.com/c/borg117" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Borg117.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.youtube.com/c/borg117" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> Borg117 </CardTitle>
                      <h6 className="card-category"> Mugen Developer </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Making the Season 2 Final and leaving <br /> all the necessary guides to understand it!
                    </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/c/borg117"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="http://thedarkside.su/Mobile.aspx?Page=forum"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-user" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

            <Col md="6">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.youtube.com/channel/UCqQMKmIoOf54NMkV0HOI-6Q" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/BobNostalgic.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.youtube.com/channel/UCqQMKmIoOf54NMkV0HOI-6Q" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> BobNostalgic </CardTitle>
                      <h6 className="card-category"> Retro games fan </h6>
                    </div>
                  </a>
                  <p className="card-description text-center">
                    Helping with the studies and tests in <br /> order to develop the new character sprites.
                    </p>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-just-icon btn-neutral"
                    color="link"
                    href="https://www.youtube.com/channel/UCqQMKmIoOf54NMkV0HOI-6Q"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-youtube-play" />
                  </Button>
                  <Button
                    className="btn-just-icon btn-neutral ml-1"
                    color="link"
                    href="https://www.facebook.com/groups/480542805368812/user/100025369098726"
                    target="_blank" rel="noopener noreferrer" 
                  >
                    <i className="fa fa-facebook" />
                  </Button>
                </CardFooter>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}

export default Developers;
